import styled from 'styled-components';
import { CustomInput } from 'reactstrap';

export default styled(CustomInput).attrs({ type: 'range' })`
  accent-color: ${({ theme }) => theme.colors.primary500};

  &::-webkit-slider-thumb {
    background: ${({ theme }) => theme.colors.primary500};
    box-shadow: none;
    cursor: pointer;
  }

  &::-moz-range-thumb {
    background: ${({ theme }) => theme.colors.primary500};
    box-shadow: none;
    cursor: pointer;
  }
`;
